import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }

});

export const figure55 = { 
chart: {
zoomType: 'xy',
animation: false,
marginTop: 40,
plotBackgroundColor: null,
plotBorderWidth: null,
plotShadow: false,
type: 'bar',
height:'600px',
backgroundColor: 'rgba(255, 255, 255, 0.0)',
style: {
fontFamily: 'Montserrat'
}
},

credits: {
enabled: false
},
title: {
text: null
},
subtitle: {
text: null
},

plotOptions: {
series: {
borderWidth: 0,
stacking: 'normal',
}
},

exporting: {
enabled: false
},


xAxis: [{
categories: [ "Pacífico nororiental", "Pacífico centro-oriental", "Pacífico sudoccidental", "Pacífico centro-occidental", "Atlántico nororiental", "Océano Índico oriental", "Atlántico sudoriental", "Océano Índico occidental", "Atlántico centro-occidental", "Atlántico noroccidental", "Atlántico centro-oriental", "Atlántico sudoccidental", "Pacífico noroccidental", "Mediterráneo y Mar Negro", "Pacífico sudoriental" ],
lineColor: "#d7d7d7",
tickColor: "#d7d7d7",
tickLength: 16,
labels: {
style: {
  fontWeight: 'normal',
  color: '#999999',
  fontSize: '12px',
}
},
}],
yAxis: [{ // Primary yAxis
labels: {
//format: '{value}',
   style: {
		  fontWeight: 'normal',
		  color: '#999999',
		  fontSize: '12px'
	  },
},
max: 100,
min: 0,
tickInterval: 10,
format: '{value.percentage}',
gridLineWidth: 0,
floor: 0,
title: {
   text: "",
   style: {
		 color: Highcharts.getOptions().colors[1]
	 }
}
}],
tooltip: {
shared: true,
useHTML: true,
hideDelay: 500,
backgroundColor: null,
borderWidth: 0,
shadow: false,
//headerFormat: '<div>{point.key}</div>',
valueSuffix: '%',
style: {
   padding: 0
}
},
legend: {
enabled: false,
},

series: [
{
	name: 'Insostenibles',
	color: '#d0cece',
	data: [ 13.8, 14.3, 15.38, 20.4, 27.3, 34.7, 35.3, 37.5, 37.8, 38.9, 40, 40, 45, 63.3, 66.7 ]
},
{
name: 'Sostenibles',
color: '#5b9bd5',
data: [  86.2, 85.7, 84.62, 79.6, 72.7, 65.3, 64.7, 62.5, 62.2, 61.1, 60, 60, 55, 36.7, 33.3 ]
},
]
}